<template>
    <div class="columns">
      <div class="column">
      <h3 class="subtitle">Carriers</h3>
      <table class="table is-fullwidth is-narrow is-striped is-hoverable">
        <thead>
        <tr>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="carrierList.length === 0 && !isLoading">
          <td colspan="4">
          No carriers have been invited as yet.
        </td>
        </tr>
        <tr v-for="invite in carrierList" :key="invite.inviteKey">
          <td>
            {{ invite.fullName }}
          </td>
          <td>
            {{ invite.phone }}
          </td>
          <td>
            {{ invite.email }}
          </td>
        </tr>
        </tbody>
      </table>
      </div>
      <div class="column">

      <h3 class="subtitle">Additional contacts</h3>
      <table class="table is-fullwidth is-narrow is-striped is-hoverable">
        <thead>
        <tr>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="otherContactsList.length === 0 && !isLoading">
          <td colspan="4">
            No additional contacts have been invited.
          </td>
        </tr>
        <tr v-for="invite in otherContactsList" :key="invite.inviteKey">
          <td>
            {{ invite.fullName }}
          </td>
          <td>
            {{ invite.phone }}
          </td>
          <td>
            {{ invite.email }}
          </td>
        </tr>
        </tbody>
      </table>
      </div>
    </div>
</template>

<script>
import InviteApi from '@/api-interface/invite'

export default {
  name: 'CompanyJobInviteList',

  props: {
    companyJobKey: {
      type: String,
      required: true
    }
  },

  created() {
    this.fetch()
  },

  data() {
    return {
      isLoading: false,
      inviteList: []
    }
  },

  computed: {
    carrierList() {
      return this.inviteList.filter((invite) => invite.inviteAccountType === 'carrier').map((invite) => {
        return {
          inviteKey: invite.inviteKey,
          fullName: `${invite.inviteAccountFirstName} ${invite.inviteAccountLastName}`,
          phone: invite.invitePhone,
          email: invite.inviteAccountEmailAddress
        }
      })
    },

    otherContactsList() {
      return this.inviteList.filter((invite) => invite.inviteAccountType === 'recipient').map((invite) => {
        return {
          inviteKey: invite.inviteKey,
          fullName: `${invite.inviteAccountFirstName} ${invite.inviteAccountLastName}`,
          phone: invite.invitePhone,
          email: invite.inviteAccountEmailAddress
        }
      })
    }
  },

  methods: {
    async fetch() {
      this.isLoading = true
      try {
        this.inviteList = await InviteApi.companyJobInviteList({ companyJobKey: this.companyJobKey })
      } catch (error) {
        console.error(`Error trying to fetch invites companyJob ${this.companyJobKey} : `, error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
